import React, { useState } from 'react';
import { Box, Stack, TableContainer, Paper } from '@mui/material';
import { listConsumableItems, RateType } from 'api/consumablesApi';
import { useQuery } from '@tanstack/react-query';
import ConsumableDetailsView from './ConsumableDetailsView';
import ConsumableFilterSection from './ConsumableFilterSection';
import { useConsumableFilters } from '../Utils/useConsumableFilters';
import BulkUpdateRatesDialog, {
  ImportRateScope,
} from './BulkUpdateRatesDialog';
import { ConsumableRatesTableComponent } from './ConsumableRatesTableComponent';
import AddConsumableItems from './AddOrEditConsumableItems';
import AddConsumableRates from './AddConsumableRates';
import AddNewRateCardItemButton from './AddNewRateCardItemButton';
import ImportRateCardMenuButton from './ImportRateCardMenuButton';

export default function ConsumableRateCardHomePage({}: {}) {
  const [modalState, setModalState] = useState({
    addConsumable: false,
    buyRate: false,
    sellRate: false,
    consumableDetailsView: false,
    reorderRanks: false,
  });
  const [selectedItemId, setSelectedItemId] = useState<string | undefined>(
    undefined
  );

  const [importScope, setImportScope] = useState<ImportRateScope | null>(
    null
  );

  const openModal = (key: keyof typeof modalState) =>
    setModalState((prev) => ({ ...prev, [key]: true }));

  const closeModal = (key: keyof typeof modalState) =>
    setModalState((prev) => ({ ...prev, [key]: false }));

  const { data: consumableData, isFetching } = useQuery(
    ['consumables-items'],
    listConsumableItems
  );

  const {
    state: filterState,
    dispatch: filterDispatch,
    activeFilterCount,
    filteredResult: filteredConsumableData,
    applyFilters,
    resetFilters,
  } = useConsumableFilters(consumableData, () => {});

  return (
    <Box sx={{ m: 3, backgroundColor: '#fff', borderRadius: 1 }}>
      <Stack
        direction="row"
        spacing={2}
        sx={{
          justifyContent: 'flex-end',
          p: '1rem',
        }}>
        <ConsumableFilterSection
          filterState={filterState}
          filterDispatch={filterDispatch}
          activeFilterCount={activeFilterCount}
          applyFilters={applyFilters}
          resetFilters={resetFilters}
          consumableData={consumableData}
          isFetching={isFetching}
        />

        <ImportRateCardMenuButton onSelect={setImportScope} />
        <AddNewRateCardItemButton
          onClickAddConsumableItem={() => openModal('addConsumable')}
          onClickAddBuyRate={() => openModal(RateType.BuyRate)}
          onClickAddSellRate={() => openModal(RateType.SellRate)}
        />
      </Stack>
      <TableContainer component={Paper}>
        <Stack
          sx={{
            marginBottom: '1rem',
          }}>
          <ConsumableRatesTableComponent
            consumableData={filteredConsumableData || consumableData}
            handleDetailsViewOpen={() => openModal('consumableDetailsView')}
            setSelectedItemId={setSelectedItemId}
          />
        </Stack>
      </TableContainer>
      <AddConsumableItems
        handleConsumableClose={() => closeModal('addConsumable')}
        openAddConsumable={modalState.addConsumable}
      />
      <AddConsumableRates
        handleSellRateFormClose={() => closeModal(RateType.SellRate)}
        handleBuyRateFormClose={() => closeModal(RateType.BuyRate)}
        openSellRateForm={modalState.sellRate}
        openBuyRateForm={modalState.buyRate}
      />
      {modalState.consumableDetailsView && (
        <ConsumableDetailsView
          handleConsumableClose={() => closeModal('consumableDetailsView')}
          selectedItemId={selectedItemId}
          open={modalState.consumableDetailsView}
        />
      )}
      {importScope && (
        <BulkUpdateRatesDialog
          open={true}
          scope={importScope}
          handleClose={() => setImportScope(null)}
        />
      )}
    </Box>
  );
}
